import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './Hello.scss';
import SEO from '../../components/SEO/SEO';

const Hello = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const h1 = containerRef.current.querySelector('h1');
    const paragraphs = containerRef.current.querySelectorAll('p');
    const image = containerRef.current.querySelector('.hello-image');

    if (!h1 || paragraphs.length === 0) return;

    // Set initial state
    const elementsToAnimate = [h1, ...paragraphs];

    gsap.set(elementsToAnimate, {
      opacity: 0,
      y: 30,
    });

    // Set initial state for image with rotation
    if (image) {
      gsap.set(image, {
        opacity: 0,
        y: 30,
        rotation: 30,
      });
    }

    const tl = gsap.timeline();

    // Animate heading
    tl.to(h1, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out',
    });

    // Animate paragraphs with stagger
    tl.to(
      paragraphs,
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.2,
      },
      '-=0.6'
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <>
      <SEO
        title="About Me - Moid Hasan Beig | Full Stack Developer"
        description="Learn about Moid Hasan Beig, a software developer based in Montreal, Canada. From electrical engineering to computer science, discover the journey of a full stack developer passionate about building clean, thoughtful UIs."
        keywords="Moid Hasan Beig, about, software developer, Montreal, Bishop's University, full stack developer, computer science"
        path="/hello"
      />
      <div className="hello-page" ref={containerRef}>
        <div className="hello-page-content">
          <h1>Hello</h1>
          <p>Thanks for visiting my page, I'm Moid 👋</p>
          <p>
            I'm a{' '}
            <b>
              <i>software developer</i>
            </b>{' '}
            who loves building clean, thoughtful UIs and working on the{' '}
            <b>
              <i>frontend</i>
            </b>
            , but I'm just as comfortable diving into the{' '}
            <b>
              <i>backend</i>
            </b>{' '}
            when needed.
          </p>
          <p>
            I started my journey as an electrical engineer in India, but
            somewhere along the way I realized my real calling was computer
            science. That decision brought me to Canada, where I completed my{' '}
            <b>
              <i>Master's in Computer Science at Bishop's University</i>
            </b>
            . Since then, I've been working as a software developer, building
            products I'm proud of and constantly learning along the way.
          </p>
          <p>
            I'm currently based in{' '}
            <b>
              <i>Montreal</i>
            </b>{' '}
            with my lovely wife and daughter. When I'm not coding, you'll
            probably find me biking around the city, whenever the weather here
            decides to cooperate.
          </p>
          <p>
            Feel free to hit me up if you want to chat about tech, design, or
            just say hi!
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export default Hello;
